import { connect } from 'react-redux';

// Placeholder. Use WebSocket-new when ready to troubleshoot and test
// LoadingWatermark removed to avoid permanent "Reconnecting..." display
function WebSocket(props) {
    return null;
};

const mapStateToProps = state => {
    return {
        auth: state.auth,
        socket: state.socket,
    };
}

export default connect(mapStateToProps, {

})(WebSocket);